export default __webpack_public_path__ + "static/media/logo-beta-1.ddf18b8c.png";